import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const DesktopComments728x90 = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Taboola, ADUNIT_MAP['DesktopComments728x90Gam'], safety, safetyState, {
        mode: 'thumbs-feed-01',
        target_type: 'mix',
        // TODO not supported afaik
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    const size = {
        width: '728px',
        height: '90px',
        overflow: 'hidden'
    };
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        style: size
    }, slotAttr));
}, adunitMemo);
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
